
const constants = {
    CENTER: 'CENTER',
    DEFAULT: 'DEFAULT',
    LEFT_RIGHT: 'LEFT_RIGHT',
    MATA: 'MATA',
    RBCDX: 'RBCDX'
}

export default constants
